export const buildStudentExamShareUrl = (linkResponse = {}, origin = window.location.origin) => {
    if (linkResponse.join_code) {
        return `${origin}/exampage?join=${encodeURIComponent(linkResponse.join_code)}`;
    }

    const backendLink = linkResponse.join_link || linkResponse.link || linkResponse.url || linkResponse.join_url;
    if (!backendLink) return '';

    try {
        const parsed = new URL(backendLink, origin);
        const match = parsed.pathname.match(/\/join\/([^/]+)\/?$/);
        return match ? `${origin}/exampage?join=${encodeURIComponent(decodeURIComponent(match[1]))}` : parsed.href;
    } catch {
        return backendLink;
    }
};

export const formatExamShareText = (exam, linkResponse, shareUrl) => [
    exam.title,
    linkResponse.join_code ? `کد ورود: ${linkResponse.join_code}` : '',
    shareUrl,
].filter(Boolean).join('\n');

export const copyTextToClipboard = async (text, options = {}) => {
    const clipboard = Object.prototype.hasOwnProperty.call(options, 'clipboard')
        ? options.clipboard
        : navigator.clipboard;
    const documentRef = options.documentRef || document;

    if (clipboard?.writeText) {
        try {
            await clipboard.writeText(text);
            return;
        } catch {
            // Some embedded browsers expose Clipboard API but reject permission.
        }
    }

    if (!documentRef?.body || typeof documentRef.execCommand !== 'function') {
        throw new Error('مرورگر اجازه کپی‌کردن لینک را نمی‌دهد.');
    }

    const input = documentRef.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    input.style.pointerEvents = 'none';
    documentRef.body.appendChild(input);
    let copied = false;
    try {
        input.focus();
        input.select();
        input.setSelectionRange(0, input.value.length);
        copied = documentRef.execCommand('copy');
    } finally {
        input.remove();
    }

    if (!copied) throw new Error('کپی‌کردن لینک انجام نشد.');
};
